<template>
    <div class="custom-modal showTabs secondary-color headerTab openHeader" @click.stop="">
    	<div class="mainContent">
    		<app-loader v-if="pageLoader"/>
    		<div class="topSettingHead position-relative border-bottom p-3">
    			<p class="f-14 mb-0">{{$t('settings') }} </p>
				<span class="closePOP" @click.prevent="close()"><feather size="13px" type="x"></feather></span>
    		</div>
    		<div class="mainTab-one">
	    	<form class="updateWrap holdBorder" @submit.prevent.stop="changeSettings()">
	    	 	<div class="twoColmn d-flex align-items-center">
	    	 		<div class="addSpsace">
						<div class="form-fields mb-3">
							<label>{{$t('select_time_zone') }}</label>
							<select class="selectBox" v-model="timezone" name="timezone">
								<!-- <option value="" disabled></option> -->
								<option :value="'1'">{{$t('server') }} </option>
								<option :value="'2'">{{$t('local_time') }} </option>
							</select>
							<span class="text-danger-error" v-if="submitted && errors.has('timezone')">
								<span class="text-danger">{{ errors.first('timezone').replace('timezone','Time Zone') }}</span>
							</span>
						</div>
					</div>
					<div class="addSpsace">
						<div class="form-fields mb-3">
								<label>{{$t('default_lot_size') }} </label>
							<div class="lightBC d-flex align-items-center darkBG">
								<input type="Number" min="0.01" max="100" step="0.01" placeholder="" v-model="lotsize" name="lotsize" v-validate="'min_value:0.01|max_value:100'" ref="lotsizeInput">
								<span class="addHighLow">
		                            <a href="javascript:void(0)" @click.stop="changeTick('lotsizeInput',1,'lotsize')"><feather type="plus"></feather> </a>
		                            <a href="javascript:void(0)" @click.stop="changeTick('lotsizeInput',0,'lotsize')"><feather type="minus"></feather> </a>
		                        </span>
	                    	</div>
							<span class="text-danger-error" v-if="submitted && errors.has('lotsize')">
								<span class="text-danger">{{ errors.first('lotsize').replace('lotsize','Lot Size') }}</span>
							</span>
							<span class="text-danger-error" v-else-if="parseFloat(lotsize) > 100">
								<span class="text-danger">{{$t('Lot Size should not be greater than') }} 100</span>
							</span>
						</div>
					</div>
			    </div>
			    <div class="twoColmn d-flex align-items-center">
			    	<div class="addSpsace">
						<div class="form-fields mb-3">
							<label>{{$t('select_history_range') }} </label>
							<select class="selectBox" v-model="history_range" name="history_range">
								<!-- <option value="" disabled>Select History Range </option> -->
								<option :value="'1'">1 {{$t('day') }}  </option>
								<option :value="'2'">15 {{$t('days') }} </option>
								<option :value="'3'">1 {{$t('month') }} </option>
								<option :value="'4'">6 {{$t('month') }}</option>
								<option :value="'5'">{{$t('custom') }}</option>
							</select>
							<span class="text-danger-error" v-if="submitted && errors.has('history_range')">
								<span class="text-danger">{{ errors.first('history_range').replace('history_range','History Range') }}</span>
							</span>
						</div>
					</div>
					<div class="addSpsace">
				    	<!-- <div class="addSpsace"> -->
						<!-- </div> -->
					    <div class="form-fields mb-3">
					    	<label>{{$t('select_show_order_slash_position_size_in') }}</label>
							<select class="selectBox" v-model="position_size" name="position_size">
								<option :value="'1'">{{$t('units') }} </option>
								<option :value="'2'">{{$t('lots') }} </option>
							</select>
							<span class="text-danger-error" v-if="submitted && errors.has('position_size')">
								<span class="text-danger">{{ errors.first('position_size').replace('position_size','Show Order / Position') }}</span>
							</span>
						</div>
					</div>
					<!-- <div class="addSpsace">
						<div class="form-fields mb-3">
							<select class="selectBox" v-model="trade_range" name="trade_range">
								<option value="" disabled>Select Default Trade Range</option>
								<option :value="val" v-for="val in 15" v-if="val >= 2">{{val}} pips </option>
								<option :value="'4'">4 pips </option>
								<option :value="'8'">8 pips </option>
								<option :value="'10'">10 pips </option>
							</select>
							<span class="text-danger-error" v-if="submitted && errors.has('trade_range')">
								<span class="text-danger">{{ errors.first('trade_range').replace('trade_range','Trade Range') }}</span>
							</span>
						</div>
					</div> -->
			    </div>
			    <div class="twoColmn d-flex align-items-center" v-if="history_range == '5'">
			    	<div class="addSpsace">
						<div class="form-fields mb-3">
							<label>{{$t('select_from_date') }}</label>
							<input type="date" v-model="FROM_DATE" :min="min_date" :max="fromMax()" name="FROM_DATE" v-validate="'required'">
							<span class="text-danger-error" v-if="submitted && errors.has('FROM_DATE')">
								<span class="text-danger">{{ errors.first('FROM_DATE').replace('FROM_DATE','FROM DATE') }}</span>
							</span>
						</div>
					</div>
					<div class="addSpsace">
						<div class="form-fields mb-3">
							<label>{{$t('select_to_date') }}</label>
							<input type="date" v-model="TO_DATE" :min="FROM_DATE" :max="future" name="TO_DATE" v-validate="'required'">
							<span class="text-danger-error" v-if="submitted && errors.has('TO_DATE')">
								<span class="text-danger">{{ errors.first('TO_DATE').replace('TO_DATE','TO DATE') }}</span>
							</span>
						</div>
					</div>
			    </div>	
			    <div class="twoColmn d-flex align-items-center">
				    <!-- <div class="addSpsace" v-if="product == 'Hanko' && ['54275125','T260630','T303164','act_test2','T196577','T304528','T259292','54275202'].includes((get_user.username || '').split('$$')[1])">
						<div class="form-fields mb-3">
					    	<label>Select Charting</label>
							<select class="selectBox" v-model="chartCompany" name="chart-company" @change="changeChart">
								<option :value="1">ChartIQ </option>
								<option :value="0">Trading View </option>
							</select>
							<span class="text-danger-error" v-if="submitted && errors.has('position_size')">
								<span class="text-danger">{{ errors.first('position_size').replace('position_size','Show Order / Position') }}</span>
							</span>
						</div>
					</div> -->
				    <div class="addSpsace">
						<div class="text-size-slider d-flex align-items-center justify-content-between my-3">
							<label>{{$t('select_font_size') }} </label>
							<div class="d-flex">
								<span class="small-letter" style="font-size: 12px;">{{$t('a') }} </span> 
								<input type="range" min="1" max="3" step="0" v-model="font_size" class="mx-2 slider pointer" value="18"> 
								<span class="big-letter" style="font-size: 24px;">{{$t('a') }}</span>
							</div>
						</div>
				    	<!-- <div class="addSpsace"> -->
						<!-- </div> -->
					    <!-- <div class="form-fields mb-3">
					    	<label>Select font size</label>
							<select class="selectBox" v-model="font_size" name="font_size">
								<option :value="'medium'">Default </option>
								<option :value="'small'">Small </option>
								<option :value="'large'">Large </option>
							</select>
							<span class="text-danger-error" v-if="submitted && errors.has('font_size')">
								<span class="text-danger">{{ errors.first('font_size').replace('font_size','font size') }}</span>
							</span>
						</div> -->
					</div>
				</div>
				<div class="twoColmn mb-3 mt-2">
					<div class="addSpsace">
						<label class="customCheckbox">{{$t('display_spread_grid_view') }}
						  <input type="checkbox" v-model="display_spread">
						  <span class="checkmark"></span>
						</label>
						<label class="customCheckbox">{{$t('display_high_slash_low_grid_view') }}
						  <input type="checkbox" v-model="display_high_low">
						  <span class="checkmark"></span>
						</label>
						<label class="customCheckbox">Display Ask line in chart
						  <input type="checkbox" v-model="display_ask_line">
						  <span class="checkmark"></span>
						</label>
					</div>
				</div>
				<div class="fullWidh w-100 text-center my-4 h-50p">
					<button class="btn appButton linkBG mx-auto justify-content-center large">{{$t('save_settings') }} </button>
				</div>
			</form>
		    </div>
    	</div>
    </div>
</template>

<script>
import { commonAllmixins } from '@/plugins/commonAll';
import { Const } from "@/plugins/commonAll/provider/lib/const.cls";
import moment from 'moment'
const product = process.env.product;
export default {
    name: 'settings',
    mixins: [commonAllmixins],
    data() {
        return {
        	pageLoader: false,
            timezone :'2',
            lotsize :'0.01',
            history_range :'4',
            trade_range :'',
            position_size :'2',
            font_size :'',
            display_spread :true,
            display_high_low :true,
            display_ask_line :true,
        	submitted: false,
        	min_date: moment().subtract(1, 'years').format('YYYY-MM-DD'),
        	FROM_DATE: moment().subtract(1, 'days').format('YYYY-MM-DD'),
			TO_DATE: moment().format('YYYY-MM-DD'),
			future : moment().format('YYYY-MM-DD'),
			chartCompany: 0,
			product
        }

		this.timezone = this.userSettings.timezone || '2'
				this.lotsize = this.userSettings.lotsize || '0.01'
				this.history_range = this.userSettings.history_range || '4'
				this.from = this.userSettings.from || ''
				this.to = this.userSettings.to || ''
				this.position_size = [1,2].includes(Number(this.userSettings.position_size))?this.userSettings.position_size:'2';
				this.font_size = this.userSettings.font_size || ''
				if(typeof(this.userSettings.display_high_low) == 'number'){
					this.display_high_low = this.userSettings.display_high_low? true: false
				}else{
					this.display_high_low = true;
				}
				if(typeof(this.userSettings.display_ask_line) == 'number'){
					this.display_ask_line = this.userSettings.display_ask_line? true: false
				}else{
					this.display_ask_line = true;
				}
				if(typeof(this.userSettings.display_spread) == 'number'){
					this.display_spread = this.userSettings.display_spread? true: false
				}else{
					this.display_spread = true;
				}
    },
    watch:{
        lotsize(val){
            this.lotsize = val.toString()
                .replace(/[^\d.]/g, '')             // numbers and decimals only
                .replace(/(^[\d]{3})[\d]/g, '$1')   // not more than 3 digits at the beginning
                .replace(/(\..*)\./g, '$1')         // decimal can't exist more than once
                .replace(/(\.[\d]{2})./g, '$1');    // not more than 2 digits after decimal
        },
    },
    methods:{
		changeChart(){
			this.$store.commit(Const.SET_APP_CHART, (this.chartCompany == 1) );
			localStorage.setItem("app-chart",this.chartCompany == 1?'chart-iq':'trading-view')
		},
    	fromMax(){
    		if(this.TO_DATE){
    			return this.TO_DATE
    		}else{
    			return this.future
    		}
    	},
    	close(){
            this.$parent.$parent.headerTab = ''
            this.$parent.$parent.openHeader = false
        },
    	changeSettings(){
    		const _that = this
            _that.submitted = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let inputJson={
                        'globalParams' :{
                            'timezone' : _that.timezone,
                            'lotsize' : _that.lotsize,
                            'history_range' : _that.history_range,
                            'from' : _that.FROM_DATE,
                            'to' : _that.TO_DATE,
                            'trade_range' : '1',
                            'font_size' : _that.font_size,
                            'position_size' : _that.position_size,
                            'display_spread' : (_that.display_spread)?'1':'0',
                            'display_high_low' : (_that.display_high_low)?'1':'0',
							other_settings : {
								'display_ask_line' : (_that.display_ask_line)?1:0
							},
							'display_ask_line' : (_that.display_ask_line)?1:0
                        },
                        'localParams' : { "parameter" : _that }
                    }
                    this._runSetUserSettings(inputJson)
                }/*else{
                    _that.handleValidationErrorAdvanced(_that.errors)
                }*/
            });
    	},
    	setStateData(){
    		if(Object.keys(this.userSettings).length > 0){
				this.timezone = this.userSettings.timezone || '2'
				this.lotsize = this.userSettings.lotsize || '0.01'
				this.history_range = this.userSettings.history_range || '4'
				this.from = this.userSettings.from || ''
				this.to = this.userSettings.to || ''
				this.position_size = [1,2].includes(Number(this.userSettings.position_size))?this.userSettings.position_size:'2';
				this.font_size = this.userSettings.font_size || ''
				if(typeof(this.userSettings.display_high_low) == 'number'){
					this.display_high_low = this.userSettings.display_high_low? true: false
				}else{
					this.display_high_low = true;
				}
				if(typeof(this.userSettings.display_ask_line) == 'number'){
					this.display_ask_line = this.userSettings.display_ask_line? true: false
				}else{
					this.display_ask_line = true;
				}
				if(typeof(this.userSettings.display_spread) == 'number'){
					this.display_spread = this.userSettings.display_spread? true: false
				}else{
					this.display_spread = true;
				}
    			// this.display_high_low = (this.userSettings.display_high_low && this.userSettings.display_high_low == '0')? false : true
				// this.display_spread = (this.userSettings.display_spread && this.userSettings.display_spread == '0')? false : true
				// console.log(this.display_high_low,this.display_spread)
				// this.trade_range = this.userSettings.trade_range || ''
    		}
    	}
	},
    created(){
    	let isChartIq = localStorage.getItem("app-chart")
		if(isChartIq == 'chart-iq'){
			this.chartCompany = 1;
		}
    	this.setStateData()
    	this._runGetUserSettings({ 'globalParams' : {},'localParams' : { 'parameter' : this, call_from: true } })
    },
    
}
</script>





// WEBPACK FOOTER //
// src/components/website/shared/sidebar-popup/settings.vue